import type { GetPresignedUrlForPostResponse } from "../types/s3";

/**
 * Validates presigned URL response from backend
 * Ensures response has required url and fields properties before attempting S3 upload
 */
export function validatePresignedResponse(
  response: unknown,
): response is GetPresignedUrlForPostResponse {
  if (!response || typeof response !== "object") return false;

  const r = response as Record<string, unknown>;

  // Validate URL exists and is non-empty string
  if (typeof r.url !== "string" || r.url.length === 0) {
    return false;
  }

  // Validate fields exists and is an object
  if (typeof r.fields !== "object" || r.fields === null) {
    return false;
  }

  const fields = r.fields as Record<string, unknown>;

  // Validate fields is not empty
  if (Object.keys(fields).length === 0) {
    return false;
  }

  // Validate required S3 POST fields exist and are non-empty strings
  const requiredFields = [
    "key",
    "policy",
    "x-amz-algorithm",
    "x-amz-credential",
    "x-amz-date",
    "x-amz-signature",
  ];

  const hasRequiredFields = requiredFields.every(
    (field) => typeof fields[field] === "string" && (fields[field] as string).length > 0,
  );

  return hasRequiredFields;
}
